import InsightSummary from './InsightSummary'

export default InsightSummary
